export default __webpack_public_path__ + "locales/de/JavascriptSdk.json?hash=f013ba31c3af3eedbbf7818519520cbb";